import React from 'react';
import HeroHome from './HeroContact';
import { Footer } from '../../components/Footer';
import ContactForm from './ContactForm';
import Xyz from './Xyz';
import Globe from './Globe';
// import contactimg from 'public/assets/img/contact/01.jpg'
function ContactUs() {
  return (
    <>
 
   
<HeroHome/>
<Xyz/>

<ContactForm/>

{/* <div class="site-breadcrumb "className="site-breadcrumb"
      style={{ backgroundImage: "url(assets/img/breadcrumb/01.jpg)" }}>
    <div class="container">
        <h2 class="breadcrumb-title">Contact Us</h2>
      
    </div>
</div> */}

    <Footer/>
    </>
  );
}

export default ContactUs;